module.exports = __webpack_public_path__ + "static/media/67.bd596264.jpg";